import { Pipe, PipeTransform } from '@angular/core';
import { RichDevice } from '@store';
import { DeviceRoles } from '@vi-iot/client/models';

@Pipe({
  name: 'isObngOutdoorUnit',
  standalone: true,
})
export class IsObngOutdoorUnitPipe implements PipeTransform {
  transform(device: RichDevice): boolean {
    return IsObngOutdoorUnitPipe.isObngOutdoorUnit(device);
  }

  static isObngOutdoorUnit(device: RichDevice): boolean {
    if (!device?.roles) {
      return false;
    }

    return (
      device.roles.some((role) => role.includes(DeviceRoles.OBNG)) &&
      device.roles.some((role) => role.includes(DeviceRoles.ProductFamilyOutdoorUnit)) &&
      device.roles.some((role) => role.includes(DeviceRoles.BusinessDomainHeating))
    );
  }
}
